import { FiRadio } from "react-icons/fi"
import AudioCaptureWrapper from "./AudioCaptureWrapper"

export default function ListenModeButton() {
  return (
    <AudioCaptureWrapper
      endpoint="/listen-mode"
      instanceId="listen-mode"
      onStatus={() => {}}
    >
      {({ isRecording: isWsRecording, isLoading, isConnected, startRecording, stopRecording }) => {
        const toggleRecord = () => {
          if (isWsRecording) stopRecording()
          else startRecording()
        }

        return (
          <button
            type="button"
            className={`listen-mode-button ${isWsRecording ? 'recording' : ''} ${
              isConnected === 'CONNECTED' ? 'connected' : ''
            }`}
            onClick={toggleRecord}
            disabled={isLoading}
            aria-label={isWsRecording ? 'Stop listen mode' : 'Start listen mode'}
            title="Listen Mode - Record all audio"
          >
            <FiRadio aria-hidden size={18} />
          </button>
        )
      }}
    </AudioCaptureWrapper>
  )
}
